<div>
	<mat-divider inset></mat-divider>
	<button
		mat-list-item
		(click)="roleSelected.emit(assignedRole)"
		[attr.data-automation-id]="'select-role-' + assignedRole.id + '-button'"
	>
		<div class="row-left inherit-height-container">
			<mat-icon svgIcon="sl-nav-work" class="select-role-icon"></mat-icon>
			<div class="column">
				<div class="row-item-company">
					{{ assignedRole.entityRelationship?.parentEntity?.name }}
				</div>
				<div class="row-item-role">{{ assignedRole.role?.name }}</div>
			</div>
		</div>
	</button>
</div>
